export default "__VITE_ASSET__Cgw4IQv6__"